import React from "react";
import { OverViewInfo } from "../ParentDashboard/OverviewInfo";
import { MyChildren } from "../ParentDashboard/MyChildren";
import { GridWrapper } from "../GridWrapper/GridWrapper";
import { NotificationListsCard } from "../NotificationComponent/NotificationListsCard";

const ParentDashboard = () => {
  return (
    <>
      <div className="flex flex-col gap-8">
        <OverViewInfo />

        <GridWrapper
          totalColumns={3}
          childrens={[
            {
              component: <MyChildren />,
              gridSpan: 2,
            },
            {
              component: <NotificationListsCard />,
              gridSpan: 1,
            },
          ]}
        />
      </div>
    </>
  );
};
export default ParentDashboard;
